import { render } from "./ImagePublicWeb.vue?vue&type=template&id=522d0296"
import script from "./ImagePublicWeb.vue?vue&type=script&lang=js"
export * from "./ImagePublicWeb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__